import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CampaignService } from "src/app/_services/campaign.service";
import { EmailPreference } from "src/app/model/campaign";
import { TransactionService } from "src/app/_services/transaction.service";
import { LocalStorageService } from "src/app/_services/local-storage.service";
import { campaignTargetListingPath, getProjectNumberFromUrl } from "src/app/email-campaign/campaign-scope.util";
declare const clevertap;

const ENRICHED_FROM = {
  Talentpool: 'talentpool',
  EmailCampaign: 'email-campaign-target-listing',
  AllCandidates: 'all-candidates',
  PersonSearch: 'person-search-listing',
  AiSourcing: 'ai-sourcing'
}
type CANDIDATE_PAYLOAD = {
  elastic_id: string,
  talentpoolcandidatemappingid: number
}
@Component({
    selector: "app-bulk-reveal-modal-component",
    templateUrl: "./bulk-reveal-modal.component.html",
    styleUrls: ["./bulk-reveal-modal.component.scss"],
    standalone: false
})


export class BulkRevealModalComponent implements OnInit {
  @Input() campaign_id;
  @Input() payload;
  @Input() emailsFound;
  @Input() total_target;
  @Input() calledFor: string = '';
  @Input() unsubscribedCandidateCount: number = 0;
  totalTargets: number = 0;
  targetsWithoutEmail: number = 0;
  @Input() campaignDetails;
  @Input() bulkRevealType;

  /**
   * TRMS-2838: inputs for calledFor === 'listing-bulk-reveal' (All Search / Project Search /
   * Project Pipeline bulk reveal). The caller has already computed exact eligibility (and
   * shown the already-revealed/pending breakdown in its own scope-selection popup) via
   * CandidateSelectionService.fetchAndComputeRevealEligibility() - this modal only shows the
   * final eligible count and submits eligibleCandidatePayload as-is via the existing bulkReveal API.
   */
  @Input() eligibleCandidatePayload: { elastic_id: string, candidatenumber: string }[] = [];
  @Input() enrichedFromOverride: string = '';

  /**
   * Data of Talentpool selected candidates
   * Used to process in the case of Reveal preference selection only in talentpool
   */
  @Input() talentpoolSelectedCandidate;

  @Output() bulkRevealModalData: EventEmitter<any> = new EventEmitter();
  displayEmailPref: string = "";

  //User Info
  userNumber: any;
  userEmailId: string;

  /**Number of Credits user have */
  creditsPresent: number = 0;
  /**Credit needed for Bulk Reveal process */
  creditsNeeded: number = 0;
  /** Max credits between providers */
  maxCredits: number = 0;
  /**Is Bulk Reveal process possible on the basis of cresits */
  canProcessBulk: boolean = true;

  /**Candidate have not enough credits to process bulk reveal */
  notEnoughCredits: boolean = false

  enrichedfrom: string;

  isLoadingBulkReveal: boolean = false;

  /** Status for preference in talentpool, By default contact number selected */
  talentpoolContactPrefStatus: string = "2";

  /**
   * Only in case of talentpool
   * Array for specific choice
   */
  candidateWithoutContactNumber: CANDIDATE_PAYLOAD[] = [];
  candidateWithoutPersonalEmail: CANDIDATE_PAYLOAD[] = [];
  candidatesWithoutProfessionalEmail: CANDIDATE_PAYLOAD[] = [];
  candidateWithoutPersonalEmailOrNumber: CANDIDATE_PAYLOAD[] = [];

  /**
   * Email should trigger for each candidate sourced data or not
   */
  candidatLevelEmail:boolean = false;

  constructor(
    private emailCampaignService: CampaignService,
    private activeModal: NgbActiveModal,
    private router: Router,
    private transactionService: TransactionService,
    private localstorageservice: LocalStorageService,
  ) { }

  async ngOnInit() {
    if (this.calledFor === 'listing-bulk-reveal') {
      // TRMS-2838: eligibility (already-revealed / pending exclusion) was already computed
      // by the caller via CandidateSelectionService.fetchAndComputeRevealEligibility() - this
      // modal only displays the exact breakdown and submits eligibleCandidatePayload as-is.
      this.totalTargets = this.eligibleCandidatePayload?.length || 0;
      this.targetsWithoutEmail = this.totalTargets;
      this.canProcessBulk = this.totalTargets > 0;
      this.enrichedfrom = this.enrichedFromOverride;
      this.payload = { enrichedfrom: this.enrichedFromOverride, candidates: this.eligibleCandidatePayload };
      this.userNumber = this.localstorageservice.getItem('usernumber');
      this.userEmailId = this.localstorageservice.getItem('usermailid');

      try {
        const res: any = await this.transactionService.fetchcurrentplandetails(this.userNumber).toPromise();
        // fetchcurrentplandetails already returns contactProviders itself (paymentFlowController's
        // fetchContactProvidersDetails step) - no separate access-details call needed for it.
        if (res && res.data) {
          this.creditsPresent = res.data?.balancebasiccontactenrichmentcredits || 0;
          if (res.data?.contactProviders?.length > 0) {
            res.data.contactProviders.forEach((x: any) => {
              this.maxCredits = Math.max(this.maxCredits, x.credit);
            })
          }
          this.creditsNeeded = this.maxCredits * this.targetsWithoutEmail;
          this.notEnoughCredits = (this.creditsNeeded <= this.creditsPresent) ? false : true;
          this.canProcessBulk = this.totalTargets > 0 && !this.notEnoughCredits;

          // Stictly for the user having unlimited credits
          if (this.creditsPresent === -1) { this.canProcessBulk = this.totalTargets > 0; this.notEnoughCredits = false; }
        }
      } catch (err) {
        console.log('Fetching credits failed !!');
      }
      return;
    }

    //Unsubcribed candidates are not allowed to add in email campaign
    this.totalTargets = this.total_target - this.unsubscribedCandidateCount;
    this.targetsWithoutEmail = this.totalTargets - this.emailsFound;
    this.canProcessBulk = (this.totalTargets === 0) ? false : true;
    this.campaignDetails && this.displayEmailPreference(this.campaignDetails.email_pref);
    this.userNumber = this.localstorageservice.getItem('usernumber');
    this.userEmailId = this.localstorageservice.getItem('usermailid');

    try {
      // Credits and access both come from the shared signals (populated on login, kept fresh by
      // CreditActivityService / AccessRefreshGuard / continent-change respectively) - no direct
      // API calls needed here.
      const res: any = { data: this.transactionService.credits() };
      const accessData = this.transactionService.access();
      if (res && res.data) {
        this.creditsPresent = res.data?.balancebasiccontactenrichmentcredits || 0;
        if (accessData?.contactProviders && accessData.contactProviders?.length > 0) {
          accessData.contactProviders.forEach((x: any) => {
            this.maxCredits = Math.max(this.maxCredits, x.credit);
          })
        }
        this.creditsNeeded = this.maxCredits * this.targetsWithoutEmail;
        this.notEnoughCredits = (this.creditsNeeded <= this.creditsPresent) ? false : true;
        this.canProcessBulk = !(this.notEnoughCredits);

        // Stictly for the user having unlimited credits
        if(this.creditsPresent === -1){ this.canProcessBulk = true; this.notEnoughCredits = false;}
      }
    } catch (err) {
      console.log('Fetching credits failed !!');
    }

    //Contditional redendring of HTML, on the basis of url
    if (this.router.url) {
      if (this.router.url.includes('person/search')) {
        this.enrichedfrom = ENRICHED_FROM.PersonSearch;
      }
      else if (this.router.url.includes('talentpool')) {
        this.enrichedfrom = ENRICHED_FROM.Talentpool;
      }
      else if (this.router.url.includes('candidate-list')) {
        this.enrichedfrom = ENRICHED_FROM.AllCandidates;
      }
      else if (this.router.url.includes('email-campaign')) {
        this.enrichedfrom = ENRICHED_FROM.EmailCampaign;
      }
      else if (this.router.url.includes('ai-sourcing')) {
        this.enrichedfrom = ENRICHED_FROM.AiSourcing;
      }
    }

    //Fuction call only when modal used for talentpool bulk reveal and not will not used on talentpoolLevel
    (this.calledFor === 'talentpool') && this.preferenceWiseDistribution();
  }

  /**
   * candidate key of bulk reveal payload will be replaced according to preference seleted
   * contactRevealPreference key will also change according to preference,
   * Have to update 'Credits Blocked', 'Candidate count', 'notEnoughCredits', 'targetsWithoutEmail, variables accordingly
   */
  preferenceSelection() {
    if(!this.talentpoolSelectedCandidate?.onTalentpoolLevel){
      if (this.talentpoolContactPrefStatus === '1') {
        // Find candidates without personal email or contact number
        this.payload.candidates = this.candidateWithoutPersonalEmailOrNumber;
      }
      else if (this.talentpoolContactPrefStatus === '2') {
        // Find candidates without contact number
        this.payload.candidates = this.candidateWithoutContactNumber;
      }
      else if (this.talentpoolContactPrefStatus === '3') {
        // Find candidates without personal email
        this.payload.candidates = this.candidateWithoutPersonalEmail;
      }
      else if (this.talentpoolContactPrefStatus === '4') {
        // Find candidates without professional
        this.payload.candidates = this.candidatesWithoutProfessionalEmail;
      }
    }

    this.targetsWithoutEmail = this.payload?.candidates?.length;
    this.totalTargets = this.payload?.candidates?.length;
    this.creditsNeeded = this.maxCredits * this.targetsWithoutEmail;
    this.notEnoughCredits = (this.creditsNeeded <= this.creditsPresent) ? false : true;
    this.canProcessBulk = (!this.notEnoughCredits && this.targetsWithoutEmail != 0);

    // Stictly for the user having unlimited credits
    if (this.creditsPresent === -1) { this.canProcessBulk = true; this.notEnoughCredits = false; }

  }

  /**
   * In case of talentpool
   * Data, will be distributed in different array on the basis of contact information
   * so that we can directly use arrays, on preference change
   */
  preferenceWiseDistribution() {
    if (!this.talentpoolSelectedCandidate?.onTalentpoolLevel && this.talentpoolSelectedCandidate?.data && this.talentpoolSelectedCandidate.data.length) {
      this.talentpoolSelectedCandidate?.data.map(x => {
        // if (!x?.talentpoolMappingDetails?.bulkcontactrevealstatus) {

        // candidates without personal email or contact number
        if (!(x?.personal_email?.length) || !(x?.mobile_phone?.length)) {
          this.candidateWithoutPersonalEmailOrNumber.push({
            elastic_id: x.basicdetails?.elastic_id,
            talentpoolcandidatemappingid: x?.talentpoolMappingDetails?.talentpoolcandidatemappingid
          })
        }

        // candidates without personal email
        if (!(x?.personal_email?.length)) {
          this.candidateWithoutPersonalEmail.push({
            elastic_id: x.basicdetails?.elastic_id,
            talentpoolcandidatemappingid: x?.talentpoolMappingDetails?.talentpoolcandidatemappingid
          })
        }

        // candidates without professional email
        if (!(x?.work_email?.length)) {
          this.candidatesWithoutProfessionalEmail.push({
            elastic_id: x.basicdetails?.elastic_id,
            talentpoolcandidatemappingid: x?.talentpoolMappingDetails?.talentpoolcandidatemappingid
          })
        }

        // candidates without contact number
        if (!(x?.mobile_phone?.length)) {
          this.candidateWithoutContactNumber.push({
            elastic_id: x.basicdetails?.elastic_id,
            talentpoolcandidatemappingid: x?.talentpoolMappingDetails?.talentpoolcandidatemappingid
          })
        }
        // }
      });

      this.preferenceSelection();
    }
  }

  /**
   * Select Radio button text on the basis of preference
   * @param preference
   * @returns {string} Preference text
   */
  selectedChoiceText(preference: string){
    switch (preference){
      // case '1' : return 'Contact Number and Personal Email ID';
      case '2' : return 'Contact Number';
      case '3' : return  'Personal Email ID';
      case '4' : return 'Professional Email ID';
    };
    return 'contact information'
  }

  bulkRevelContacts() {
    this.isLoadingBulkReveal = true;
    this.payload.enrichedFrom = this.enrichedfrom;
    this.payload.candidate_level_email = this.candidatLevelEmail;
    if(this.enrichedfrom === 'talentpool'){
      this.payload.contactRevealPreference = Number(this.talentpoolContactPrefStatus);
    }
    this.canProcessBulk && this.emailCampaignService.bulkReveal(this.payload).subscribe((res: any) => {
      this.fetchcredits();
      if (res && res.status == 'success') {
        this.isLoadingBulkReveal = false;
        this.activeModal.dismiss();
      //  (this.calledFor === 'email-campaign') && this.router.navigateByUrl(`email-campaign/target-listing/${this.campaign_id}`);
        (this.calledFor === 'talentpool' || this.calledFor === 'listing-bulk-reveal') && this.bulkRevealModalData.emit({status: 'success', data: res?.data});
          /**
           *Bulk reveal
           */
           const bulkRevealParams = {
            "User ID": this.localstorageservice.getItem('userdata').userid,
            "Talentpool ID": this.payload.talentpoolnumber,
            "Contact Preference": this.talentpoolContactPrefStatus,
            "No Of Candidates": this.payload.candidates.length,
            "Source": this.bulkRevealType
          }
          clevertap.event.push('Bulk Reveal', bulkRevealParams);
      }
    }, (err) => {
      this.fetchcredits();
      if (err) {
        this.isLoadingBulkReveal = false;
        this.activeModal.dismiss();
       // (this.calledFor === 'email-campaign') && this.router.navigateByUrl(`email-campaign/target-listing/${this.campaign_id}`);
        (this.calledFor === 'talentpool' || this.calledFor === 'listing-bulk-reveal') && this.bulkRevealModalData.emit({status: 'failure', data: null});
      }
    });
  }

  /**Get the latest credits available */
  fetchcredits() {
    this.transactionService.fetchcurrentplandetails(this.localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        let userData = this.localstorageservice.getItem('userdata');
        userData['balancebasiccontactenrichmentcredits'] = res.data.balancebasiccontactenrichmentcredits;
        this.localstorageservice.setItem('userdata', userData);
        this.transactionService.createPaymentData();
      }
    })
  }


  closeModal(type?: string) {
    this.activeModal.dismiss();
    (type === 'redirect') && this.router.navigate(campaignTargetListingPath(this.campaign_id, getProjectNumberFromUrl()));
  }

  //Only Trigger when modal used for email campaign bulk reveal
  displayEmailPreference(emailPref: EmailPreference) {
    switch (emailPref) {
      case EmailPreference.Personal:
        this.displayEmailPref = "personal email";
        break;
      case EmailPreference.Professional:
        this.displayEmailPref = "professional email";
        break;
      case EmailPreference.PersonalProfessional:
        this.displayEmailPref = "personal/professional email";
        break;
      case EmailPreference.ProfessionalPersonal:
        this.displayEmailPref = "professional/personal email";
        break;
    }
  }
}
